// import React, { useState, useEffect } from 'react';
// import Masonry from 'react-layout-masonry';
// import './features.css';
// import Modale from '../../containers/feed/Feed';
// import Modal from '../../@/components/modal/Modal';
// import { getDocs, collection } from 'firebase/firestore';
// import { db } from '../../firebase'; 
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import DOMPurify from 'dompurify';

// const Features = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [modalImage, setModalImage] = useState('');
//   const [posts, setPosts] = useState([]);
//   const [categories] = useState([
//     { id: 1, name: "Architectural Design", value: "Articles" },
//     { id: 2, name: "Industrial Design", value: "Events" },
//     { id: 3, name: "Graphics Design", value: "News" },
//     { id: 4, name: "Fashion Design", value: "Fashion" }, 
//   ]);
//   const [selectedCategory, setSelectedCategory] = useState('Articles');
//   const [modalPost, setModalPost] = useState(null);

//   useEffect(() => {
//     const fetchPosts = async () => {
//       const postsCollection = collection(db, 'news'); 
//       const snapshot = await getDocs(postsCollection);
//       const fetchedPosts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

//       // Sort posts by creation timestamp in descending order
//       fetchedPosts.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);
      
//       setPosts(fetchedPosts);
//     };
//     fetchPosts();
//   }, []);

//   const handleReadMore = (index) => {
//     const clickedPost = filterPosts()[index];
//     const postWithImage = { ...clickedPost, image: clickedPost.image };
//     setModalPost(postWithImage);
//   };

//   const openModal = (image) => {
//     setModalImage(image);
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   const handleCategoryChange = (value) => {
//     setSelectedCategory(value);
//   };

//   const formatDate = (date) => {
//     if (!date) return '';
//     const options = { day: 'numeric', month: 'long', year: 'numeric' };
//     return new Date(date).toLocaleDateString('en-GB', options);
//   };

//   const filterPosts = () => {
//     if (!posts || posts.length === 0) {
//       return [];
//     }

//     let filteredPosts = posts.filter(post => post.isPublished);

//     if (selectedCategory === 'Articles') {
//       return filteredPosts;
//     }

//     return filteredPosts.filter(post => post.category === selectedCategory);
//   };

//   const createMarkup = (html) => {
//     return { __html: DOMPurify.sanitize(html) };
//   };

//   return (
//     <>
//       <div className="post-grid section__padding">
//         <div className="category-buttons">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               className={selectedCategory === category.value ? 'active' : ''}
//               onClick={() => handleCategoryChange(category.value)}
//             >
//               {category.name}
//             </button>
//           ))}
//         </div>
//         <div className="w-[100%] p-4">
//           <div className="grid grid-cols-3 gap-6">
//             {filterPosts().map((post, index) => (
//               <div key={post.id} className="mb-8">
//                 <div className="h-[300px] w-full overflow-hidden">
//                   <BlurhashImg
//                     src={post.coverImage}
//                     alt="Post Featured Image"
//                     className="responsive blur_load"
//                     id={`clickableImage${post.id}`}
//                     loading="lazy"
//                     placeholderColor="#888"
//                   />
//                 </div>
//                 <p style={{ color: "#CD3333" }}>{post.date}</p>
//                 <h1 style={{ fontSize: "25px", fontWeight: "600" }}>{post.title}</h1>
//                 <p
//                   dangerouslySetInnerHTML={{
//                     __html: post.content.length > 250
//                       ? post.content.slice(0, 250) + '...'
//                       : post.content,
//                   }}
//                   style={{ color: "#000" }}
//                 ></p>
//               </div>
//             ))}
//           </div>
//         </div>
//         <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
//         {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />}
//       </div>
//     </>
//   );
// };

// export default Features;






// import React, { useState, useEffect } from 'react';
// import Masonry from 'react-layout-masonry';
// import './features.css';
// import Modale from '../../containers/feed/Feed';
// import Modal from '../../@/components/modal/Modal';
// import { getDocs, collection } from 'firebase/firestore';
// import { db } from '../../firebase'; 
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import DOMPurify from 'dompurify';
// import architectural from '../../main_assets/design1.png'
// import industrial from '../../main_assets/design2.png'
// import graphics from '../../main_assets/design3.png'

// const Features = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [modalImage, setModalImage] = useState('');
//   const [posts, setPosts] = useState([]);
//   const [visibleCount, setVisibleCount] = useState(9); 
//   const [selectedImage, setSelectedImage] = useState('../../main_assets/about.png');
//   // const [categories] = useState([
//   //   { id: 1, name: "Architectural Design", value: "Articles" },
//   //   { id: 2, name: "Industrial Design", value: "Events" },
//   //   { id: 3, name: "Graphics Design", value: "News" },
//   //   { id: 4, name: "Fashion Design", value: "Fashion" }, 
//   // ]);
//   const [categories] = useState([
//     { 
//       id: 1, 
//       name: "Architectural Design", 
//       value: "Articles",
//       image: architectural
//     },
//     { 
//       id: 2, 
//       name: "Industrial Design", 
//       value: "Events",
//       image: industrial
//     },
//     { 
//       id: 3, 
//       name: "Graphics Design", 
//       value: "News",
//       image: graphics
//     },
//     { 
//       id: 4, 
//       name: "Fashion Design", 
//       value: "Fashion",
//       image: "/path-to-fashion-image.jpg"
//     },
//   ]);
//   const [selectedCategory, setSelectedCategory] = useState('Articles');
//   const [modalPost, setModalPost] = useState(null);

//   useEffect(() => {
//     const category = categories.find(cat => cat.value === selectedCategory);
//     if (category) {
//       setSelectedImage(category.image);
//     }
//   }, [selectedCategory, categories]);

//   useEffect(() => {
//     const fetchPosts = async () => {
//       const postsCollection = collection(db, 'news'); 
//       const snapshot = await getDocs(postsCollection);
//       const fetchedPosts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

//       fetchedPosts.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);
      
//       setPosts(fetchedPosts);
//     };
//     fetchPosts();
//   }, []);

//   const loadMore = () => {
//     setVisibleCount(prevCount => prevCount + 9); 
//   };

//   const handleReadMore = (index) => {
//     const clickedPost = filterPosts()[index];
//     const postWithImage = { ...clickedPost, image: clickedPost.image };
//     setModalPost(postWithImage);
//   };

//   const openModal = (image) => {
//     setModalImage(image);
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   // const handleCategoryChange = (value) => {
//   //   setSelectedCategory(value);
//   //   setVisibleCount(9); 
//   // };

//   const handleCategoryChange = (value) => {
//     setSelectedCategory(value);
//     setVisibleCount(9);
    
//     const category = categories.find(cat => cat.value === value);
//     if (category) {
//       setSelectedImage(category.image);
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return '';
//     const options = { day: 'numeric', month: 'long', year: 'numeric' };
//     return new Date(date).toLocaleDateString('en-GB', options);
//   };

//   const filterPosts = () => {
//     if (!posts || posts.length === 0) {
//       return [];
//     }

//     let filteredPosts = posts.filter(post => post.isPublished);

//     if (selectedCategory === 'Articles') {
//       return filteredPosts;
//     }

//     return filteredPosts.filter(post => post.category === selectedCategory);
//   };

//   const createMarkup = (html) => {
//     return { __html: DOMPurify.sanitize(html) };
//   };

//   const filteredPosts = filterPosts();
//   const hasMorePosts = visibleCount < filteredPosts.length;

//   return (
//     <>
//       <div className="post-grid-dep">
//         <div className="gpt3__header-image" style={{ fontFamily: "Poppins-SemiBold", position: 'relative' }}>
//           <BlurhashImg
//             src={selectedImage}
//             alt={`${selectedCategory} category`}
//             className="w-full h-full object-cover"
//             loading="lazy"
//             placeholderColor="#888"
//           />
//           <div className="about-us-text" style={{ fontFamily: "Poppins-SemiBold"}}>
//             <p>{categories.find(cat => cat.value === selectedCategory)?.name}</p>
//           </div>
//         </div>
//         {/* <div className="category-buttons">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               className={selectedCategory === category.value ? 'active' : ''}
//               onClick={() => handleCategoryChange(category.value)}
//             >
//               {category.name}
//             </button>
//           ))}
//         </div> */}
//         <div className="category-buttona">
//           {categories.map((category) => (
//             <button
//               key={category.id}
//               className={`${selectedCategory === category.value ? 'active' : ''} 
//                          px-4 py-2 rounded-lg transition-all duration-300`}
//               onClick={() => handleCategoryChange(category.value)}
//             >
//               {category.name}
//             </button>
//           ))}
//         </div>
//         <div className="w-[100%] p-4 section__paddinga-Features">
//           <div className="grid grid-cols-3 gap-6">
//             {filteredPosts.slice(0, visibleCount).map((post, index) => (
//               <div key={post.id} className="mb-8">
//                 <div className="h-[300px] w-full overflow-hidden">
//                   <BlurhashImg
//                     src={post.coverImage}
//                     alt="Post Featured Image"
//                     className="responsive blur_load"
//                     id={`clickableImage${post.id}`}
//                     loading="lazy"
//                     placeholderColor="#888"
//                   />
//                 </div>
//                 <p style={{fontFamily: "Poppins-Regular", color: "#CD3333", fontSize: "16px", marginTop: "12px" }}>{post.category}</p>
//                 <h1 style={{fontFamily: "Poppins-SemiBold", fontSize: "26px", fontWeight: "600", lineHeight: "1.2", paddingTop: '6px' }}>{post.title}</h1>
//                 <p
//                   dangerouslySetInnerHTML={{
//                     __html: post.content.length > 250
//                       ? post.content.slice(0, 250) + '...'
//                       : post.content,
//                   }}
//                   style={{fontFamily: "Poppins-Light", lineHeight: "1.3", color: "#000000", fontSize: '14px', paddingTop: '6px' }}
//                 ></p>
//               </div>
//             ))}
//           </div>

//           {hasMorePosts && (
//             <div className="load-more-container" style={{ display: 'flex', justifyContent: 'center' }}>
//               <button onClick={loadMore} 
//                 className="load-more-button"
//                 style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontWeight: "600", textAlign: "center", paddingTop: "4rem" }}
//               >
//                 Load More Stories
//               </button>
//             </div>
//           )}
//         </div>
//         <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
//         {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />}
//       </div>
//     </>
//   );
// };

// export default Features;












import React, { useState, useEffect, useRef } from 'react';
import Masonry from 'react-layout-masonry';
import './features.css';
import Modale from '../../containers/feed/Feed';
import Modal from '../../@/components/modal/Modal';
import { getDocs, collection, query, where, doc, updateDoc, increment, FieldValue } from 'firebase/firestore';
import { db } from '../../firebase'; 
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaPinterest, FaCopy } from 'react-icons/fa';

//assets
import architectural from '../../main_assets/design1.png'
import industrial from '../../main_assets/design2.png'
import graphics from '../../main_assets/design3.png'

const incrementShareCount = async (postId) => {
  try {
    const postRef = doc(db, 'news', postId);
    await updateDoc(postRef, { 
      shareCount: increment(1) 
    });
  } catch (error) {
    console.error("Error incrementing share count:", error);
  }
};


const Features = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(9);
  // const [selectedImage, setSelectedImage] = useState('../../main_assets/about.png');
  const [selectedImage, setSelectedImage] = useState(architectural);
  const [selectedCategory, setSelectedCategory] = useState('Architectural'); 
  const [modalPost, setModalPost] = useState(null);
  const [activePopupPostId, setActivePopupPostId] = useState(null);
  const [hoverPostId, setHoverPostId] = useState(null);
  const [localShareCounts, setLocalShareCounts] = useState({});
  const [copiedPostId, setCopiedPostId] = useState(null);
  const shareRefsMap = useRef({});
  
  const [categories] = useState([
    { 
      id: 1, 
      name: "Architectural Design", 
      value: "Architectural",
      image: architectural
    },
    { 
      id: 2, 
      name: "Industrial Design", 
      value: "Industrial",
      image: industrial
    },
    { 
      id: 3, 
      name: "Graphics Design", 
      value: "Graphics",
      image: graphics
    },
    { 
      id: 4, 
      name: "Fashion Design", 
      value: "Fashion",
      image: "/path-to-fashion-image.jpg"
    },
  ]);
  

  const loadMore = () => {
    setVisibleCount(prevCount => prevCount + 9); 
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    setVisibleCount(9);
    
    const category = categories.find(cat => cat.value === value);
    if (category) {
      setSelectedImage(category.image);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  // const [selectedCategory, setSelectedCategory] = useState('Articles');
  

  useEffect(() => {
    const category = categories.find(cat => cat.value === selectedCategory);
    if (category) {
      setSelectedImage(category.image);
    }
  }, [selectedCategory, categories]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const postsCollection = collection(db, 'news');
        
        // Log the collection reference
        console.log('Fetching from collection:', postsCollection.path);
        
        const snapshot = await getDocs(postsCollection);
        
        // Log the number of documents retrieved
        console.log('Number of documents retrieved:', snapshot.docs.length);
        
        const fetchedPosts = snapshot.docs.map(doc => {
          const data = doc.data();
          
          // Log each post's data for debugging
          console.log(`Post ${doc.id} data:`, {
            id: doc.id,
            title: data.title,
            category: data.category,
            isPublished: data.isPublished,
            createdAt: data.createdAt,
            coverImage: data.coverImage
          });
          
          return { 
            id: doc.id, 
            ...data,
            // Ensure isPublished has a default value
            isPublished: data.isPublished !== undefined ? data.isPublished : true
          };
        });

        // Sort posts with error handling
        fetchedPosts.sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateB - dateA;
        });

        console.log('Processed posts:', fetchedPosts);
        setPosts(fetchedPosts);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    // Add click event listener to close popup when clicking outside
    const handleClickOutside = (event) => {
      let isClickInsideShareArea = false;
      
      // Check if the click is inside any of the share areas
      Object.values(shareRefsMap.current).forEach(ref => {
        if (ref && (ref.buttonRef.contains(event.target) || 
            (ref.popupRef && ref.popupRef.contains(event.target)))) {
          isClickInsideShareArea = true;
        }
      });

      if (!isClickInsideShareArea) {
        setActivePopupPostId(null);
        setHoverPostId(null);
        setCopiedPostId(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    fetchPosts();

    // Cleanup event listener
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const filterPosts = () => {
    if (!posts || posts.length === 0) {
      console.log('No posts available to filter');
      return [];
    }

    let filteredPosts = posts.filter(post => {
      const isVisible = post.isPublished;
      console.log(`Post ${post.id} visibility:`, isVisible);
      return isVisible;
    });

    if (selectedCategory === 'Articles') {
      console.log('Showing all articles:', filteredPosts.length);
      return filteredPosts;
    }

    const categoryFiltered = filteredPosts.filter(post => post.category === selectedCategory);
    console.log(`Posts in category ${selectedCategory}:`, categoryFiltered.length);
    return categoryFiltered;
  };


  const handleShareButtonClick = (postId) => {
    // Toggle the popup
    setActivePopupPostId(prevId => prevId === postId ? null : postId);
    // Ensure hover is also set to allow persistent display
    setHoverPostId(postId);
  };

  const handleCopyLink = (postId) => {
    const articleUrl = `https://yourwebsite.com/article/${postId}`;
    
    // Copy to clipboard
    navigator.clipboard.writeText(articleUrl).then(() => {
      // Set copied state and reset after 2 seconds
      setCopiedPostId(postId);
      setTimeout(() => setCopiedPostId(null), 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  const handleSocialShare = async (postId, socialPlatform) => {
    try {
      // Increment local share count immediately
      setLocalShareCounts(prev => ({
        ...prev,
        [postId]: (prev[postId] || 0) + 1
      }));

      // Increment share count in Firestore
      await incrementShareCount(postId);

      // Open the share dialog for the specific social platform
      let shareUrl = '';
      const articleUrl = `https://yourwebsite.com/article/${postId}`;
      
      switch(socialPlatform) {
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl)}`;
          break;
        case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(articleUrl)}`;
          break;
        case 'instagram':
          // Note: Instagram doesn't allow direct sharing via web
          alert('Instagram sharing is not directly supported. Please copy the link.');
          return;
        case 'pinterest':
          shareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(articleUrl)}`;
          break;
        default:
          return;
      }

      window.open(shareUrl, '_blank');
    } catch (error) {
      console.error("Error sharing post:", error);
    }
  };

//   if (loading)
//   return (
//     <div className="loading-container">
//       <div className="spinner"></div>
//       <p>Loading projects...</p>
//     </div>
//   );
// if (error)
//   return (
//     <div className="error-container">
//       <div className="error-icon">⚠️</div>
//       <p>Error: {error}</p>
//     </div>
//   );

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading article...</p>
      </div>
    );
  }



  const filteredPosts = filterPosts();
  const hasMorePosts = visibleCount < filteredPosts.length;

  const getFirstTextSection = (article) => {
    // If no sections exist, return first 250 chars of main content
    if (!article?.sections?.length) {
      const mainContent = article?.content || '';
      return mainContent.length > 120 ? mainContent.slice(0, 120) + '...' : mainContent;
    }
  
    // Find the first text section
    const firstTextSection = article.sections.find(section => section.type === 'text');
    
    // If no text section found, return empty string
    if (!firstTextSection?.content) return '';
    
    // Strip HTML tags but preserve line breaks and spaces
    const stripHtml = (html) => {
      // Replace line breaks with spaces
      const withLineBreaks = html.replace(/<br\s*\/?>/gi, ' ').replace(/<\/p>/gi, ' ');
      // Remove all HTML tags
      const withoutTags = withLineBreaks.replace(/<[^>]*>/g, '');
      // Remove multiple spaces and trim
      return withoutTags.replace(/\s+/g, ' ').trim();
    };
  
    // Get plain text content
    const plainText = stripHtml(firstTextSection.content);
    
    // Return first 250 chars
    return plainText.length > 120 ? plainText.slice(0, 120) + '...' : plainText;
  };

return (
  <>
    <div className="post-grid-dep">
      <div className="gpt3__header-image responsive-header-image" style={{ fontFamily: "Poppins-SemiBold", position: 'relative' }}>
        <BlurhashImg
          src={selectedImage}
          alt={`${selectedCategory} category`}
          className="w-full h-full object-cover"
          loading="lazy"
          placeholderColor="#888"
          onError={(e) => {
            console.error('Error loading category image:', selectedImage);
            e.target.src = '/fallback-image.jpg';
          }}
        />
        <div className="about-us-text responsive-about-text" style={{ fontFamily: "Poppins-SemiBold", fontSize: "clamp(28px, 4vw, 37px)"}}>
          <p>{categories.find(cat => cat.value === selectedCategory)?.name}</p>
        </div>
      </div>

      <div className="category-buttona responsive-category-buttons">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`${selectedCategory === category.value ? 'active' : ''} 
                       px-4 py-2 rounded-lg transition-all duration-300`}
            onClick={() => handleCategoryChange(category.value)}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div className="w-[100%] p-4 section__paddinga-Features">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* <div className="works-container-page">
        <div className="work-cards-page"> */}
          {filteredPosts.slice(0, visibleCount).map((post) => (
            <Link 
              to={`/article/${post.id}`} 
              key={post.id} 
              className="mb-8 cursor-pointer duration-300"
            >
              <div>
                {/* <div className="h-[250px] md:h-[350px] w-full overflow-hidden"> */}
                <div className="relative aspect-[16/9] w-full overflow-hidden">
                  <BlurhashImg
                    src={post.coverImage}
                    alt={post.title}
                    className="w-full h-full object-cover responsive blur_load"
                    id={`clickableImage${post.id}`}
                    loading="lazy" 
                    placeholderColor="#888"
                    onError={(e) => {
                      console.error('Error loading image:', post.coverImage);
                      e.target.src = '/fallback-image.jpg';
                    }}
                  />
                </div>
                <div className="mt-4">
                  <p style={{
                    fontFamily: "Poppins-Regular",
                    color: "#CD3333",
                    fontSize: "16px"
                  }}>
                    {post.category}
                  </p>
                  <h3 style={{
                    fontFamily: "Poppins-SemiBold",
                    fontSize: "26px",
                    fontWeight: "600",
                    lineHeight: "1.2",
                    paddingTop: '6px'
                  }}>
                    {post.title}
                  </h3>
                  <div 
                    style={{
                      fontFamily: "Poppins-Light",
                      lineHeight: "1.3",
                      color: "#000000",
                      fontSize: '14px',
                      paddingTop: '6px'
                    }}
                    dangerouslySetInnerHTML={{ 
                      __html: (() => {
                        const content = getFirstTextSection(post);
                        if (!content) return 'No content available';
                        return content.length > 250 ? content.slice(0, 250) + '...' : content;
                      })()
                    }} 
                  />
                </div>
                <div 
                  className="flex items-center mt-2 relative"
                  onMouseEnter={() => setHoverPostId(post.id)}
                  onMouseLeave={() => {
                    // Only remove hover if not actively clicked
                    if (activePopupPostId !== post.id) {
                      setHoverPostId(null);
                    }
                  }}
                >
                  <p style={{
                    fontFamily: "Poppins-Light",
                    fontSize: "16px",
                    color: "#CD3333",
                  }}>
                    {new Date(post.createdAt?.seconds * 1000).toLocaleDateString()}
                  </p>

                  <span className="ml-12" style={{color: "#CD3333"}}>
                    {/* {localShareCounts[post.id] || post.shareCount || 0} */}
                  </span>
                  <button 
                    ref={(el) => {
                      if (el) {
                        if (!shareRefsMap.current[post.id]) {
                          shareRefsMap.current[post.id] = {};
                        }
                        shareRefsMap.current[post.id].buttonRef = el;
                      }
                    }}
                    className="share-button ml-2"
                    onClick={(e) => {
                      e.stopPropagation(); 
                      e.preventDefault(); 
                      handleShareButtonClick(post.id);
                    }}
                    style={{color: "#CD3333"}}
                  >
                    Share
                  </button>

                  {(hoverPostId === post.id || activePopupPostId === post.id) && (
                    <div 
                      ref={(el) => {
                        if (el) {
                          if (!shareRefsMap.current[post.id]) {
                            shareRefsMap.current[post.id] = {};
                          }
                          shareRefsMap.current[post.id].popupRef = el;
                        }
                      }}
                      className="social-popup absolute z-10 bg-white border border-gray-200 p-3 rounded shadow-lg"
                      onClick={(e) => e.stopPropagation()} 
                    >
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="issue-details__social-link-feed"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSocialShare(post.id, 'facebook');
                        }}
                      >
                        <FaFacebook />
                      </a>
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="issue-details__social-link-feed"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSocialShare(post.id, 'twitter');
                        }}
                      >
                        <FaTwitter />
                      </a>
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="issue-details__social-link-feed"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSocialShare(post.id, 'instagram');
                        }}
                      >
                        <FaInstagram />
                      </a>
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="issue-details__social-link-feed"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSocialShare(post.id, 'pinterest');
                        }}
                      >
                        <FaPinterest />
                      </a>
                      <a
                        href="#"
                        className={`issue-details__social-link-feed ${
                          copiedPostId === post.id ? 'text-green-500' : ''
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleCopyLink(post.id);
                        }}
                        title={copiedPostId === post.id ? 'Copied!' : 'Copy Link'}
                      >
                        {copiedPostId === post.id ? '✓ Copied' : <FaCopy />}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </Link>
            
          ))}
        </div>

        {hasMorePosts && (
          <div className="load-more-container" style={{ display: 'flex', justifyContent: 'center' }}>
            <button 
              onClick={loadMore} 
              className="load-more-button responsive-load-more"
              style={{ 
                fontFamily: "Poppins-SemiBold", 
                color: "#CD3333", 
                fontWeight: "600", 
                textAlign: "center", 
                paddingTop: "4rem" 
              }}
            >
              Load More Stories
            </button>
          </div>
        )}
      </div>

      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
      {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />}
    </div>
  </>
);
};

export default Features;